(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('TopNavbarController', TopNavbarController);

    TopNavbarController.$inject = ['$localStorage', '$state', 'Auth', 'StoreService', '$rootScope', 'Principal', '$scope', '$translate',
        '$uibModal', 'Constants', 'NotificationService', 'WsService', 'SettingsService', 'ChatService', 'ErpsSettingsService',
        'WebhookStatusService'];

    function TopNavbarController($localStorage, $state, Auth, StoreService, $rootScope, Principal, $scope, $translate,
        $uibModal, Constants, NotificationService, WsService, SettingsService, ChatService, ErpsSettingsService,
        WebhookStatusService) {

        var storeChangeSuccess = $scope.$on('storeChangeSuccess', storeChangeSuccessHandler);
        var NOTIFICATION_AUDIO_FILE = "../../assets/audio/notification_sound.mp3"
        var ERPS_SETTINGS_STATE = 'erps-settings';
        var CHECKOUT_PATH = '/checkout';

        var vm = this;

        vm.logout = logout;
        vm.changeSession = changeSession;
        vm.changeState = changeState;
        vm.hub = $localStorage.hub;

        vm.myStoresLoading = false;
        vm.notificationsCount = 0;
        vm.messagesCount = 0;
        vm.configuration = null;
        vm.hasWebhookErrors = false;
        vm.whatsappSupportMessage = null;
        vm.profileImage = null;
        vm.isHubContext = $localStorage.defaultStore.hubContext;
        vm.isImmoContext = $localStorage.defaultStore.immoContext;

        vm.AlertType = {
            INTEGRATION: 'INTEGRATION',
            WEBHOOK: 'WEBHOOK',
            TRIAL: 'TRIAL'
        };

        $rootScope.$on("UpdateNotificationCount", function(){
            $scope.parentmethod();
        });

        $scope.parentmethod = function() {
            getNotificationsInfo();
        }

        $rootScope.$on("settings-updated", function() {
            SettingsService.getRegister($localStorage.userId, $localStorage.defaultStore.storeId).then(function (data) {
                vm.systemNotificationsSound = data['soundNotification'];
            });
        });

        init();

        function init() {
            loadAccount();
            loadErpConfiguration();
            loadWebhookErrorStatus();
        }

        function loadAccount() {
            Principal.identity().then(function(account) {
                if (account){
                    vm.account = angular.copy(account);

                    if (vm.account.accountDTO && vm.account.accountDTO.imageProfile && vm.account.accountDTO.imageProfile.path) {
                        vm.profileImage = vm.account.accountDTO.imageProfile.path;
                    }

                    updateDistance();
                    if (vm.account.userProfiles){
                        vm.userProfile = vm.account.userProfiles[0];
                        vm.isAdminAccount = vm.account.userProfiles[0].storeId == $rootScope.ADMIN_SYSTEM_ID;
                    }
                    if (!vm.isAdminAccount) {
                        getMyStores();
                        getStoreInfo();
                    }
                    getNotificationsInfo();
                    subscribeButtonHandler();
                }
            });
        }

        function loadErpConfiguration() {
            if ($localStorage.defaultStore) {
                ErpsSettingsService.getERPConfigurationByStoreId($localStorage.defaultStore.storeId)
                    .then(function (response) {
                        if (response.data && response.data.id) {
                            vm.configuration = response.data;
                        updateDistance();
                        }
                    });
            }
        }

        function loadWebhookErrorStatus() {
            WebhookStatusService.getErrorStatus().then(function (response) {
                vm.hasWebhookErrors = !!(response.data && response.data.hasWebhookErrors === true);
                updateDistance();
            }, function () {
                vm.hasWebhookErrors = false;
            });
        }

        vm.getWhatsappIntegrationMessage = function() {
            var storeName = vm.store.name;
            var erpName = vm.getErpName();
            var message = $translate.instant('global.top-navbar.message.warning.whatsapp-support-message',
                { storeName: storeName, erpName: erpName });
            return 'https://api.whatsapp.com/send?phone=+558398931539&text='.concat(message);
        }

        vm.getTrialWarningMessage = function() {
            return $translate.instant('global.top-navbar.message.warning.trial',
                { remainingTime: vm.account.remainingTime });
        }

        vm.getIntegrationTokenFailedWarningMessage = function() {
            var erpName = vm.getErpName();
            return $translate.instant('global.top-navbar.message.warning.integration-token-failed',
                { erpName: erpName });
        }

        vm.getIntegrationUnexpectedWarningMessage = function() {
            var erpName = vm.getErpName();
            return $translate.instant('global.top-navbar.message.warning.integration-unexpected-failed',
                { erpName: erpName });
        }

        function playAudio() {
            var audio = new Audio();
            audio.src = NOTIFICATION_AUDIO_FILE;
            audio.load();
            audio.play();
        }

        function subscribeOnNotification(message) {
            getNotificationsInfo();
            playAudio();
        }

        function updateNotifications(message) {
            getNotificationsInfo();
        }

		vm.giftCardCheckout = function (){
			/*PlanModalFactory.choosePlan().then(function() {
            });*/
 			return $uibModal.open({
                templateUrl: 'app/account/checkout/gift-card/gift-card-checkout.html',
                controller: 'GiftCardCheckoutController',
                controllerAs: 'vm',
                size: 'lg',
                keyboard : false
            }).result;
		}

        function getNotificationsInfo() {
            NotificationService.getNotificationInfo(
                $localStorage.defaultStore.storeId,
                vm.account.id
            ).then(function (data) {
                vm.notificationsCount = data.notificationsCount;
                vm.messagesCount = data.messagesCount;
            });
        }

        function getStoreInfo() {
            if ($localStorage.defaultStore){
                StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
                    vm.store = response.data;
                    $localStorage.defaultStore.category = vm.store.categoryKey;
                    if(!vm.account.acceptedTerm) {
                        vm.account.acceptedTerm = true;
                        vm.checkedTermOfUse(vm.store.storeType);
                        subscribeButtonHandler();
                    }
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                });

                WsService.getInfo().then(function (result) {
                    vm.wsToken = result.token;

                    ChatService.connectWS(function () {
                        ChatService.subscribeOnNewNotifications($localStorage.defaultStore.storeId, subscribeOnNotification);
                        ChatService.subscribeOnNewNotifications(vm.account.id, subscribeOnNotification);
                        ChatService.subscribeOnUpdateNotifications($localStorage.defaultStore.storeId, updateNotifications);
                    });
                });
            }

        }

        function updateDistance()  {
            var cct = document.getElementById('cct');
            var breadcrumb = document.getElementById('breadcrumb');
            var navMenu = document.getElementById('nav-menu');
            var hasError = !!vm.getActiveAlertType();
            $rootScope.hasTopNavbarError = hasError;

            if (hasError) {
                if(cct) {
                    cct.style.marginTop = "85px"
                }
                if(breadcrumb) {
                    breadcrumb.style.marginTop = "35px"
                }
                if(navMenu) {
                    navMenu.style.marginTop = "35px"
                }
            } else {
                if(cct) {
                    cct.style.marginTop = "0"
                }
                if(breadcrumb) {
                    breadcrumb.style.marginTop = "0"
                }
                if(navMenu) {
                    navMenu.style.marginTop = "0"
                }
            }
        }

        function logout() {
            var failedAudioMessages = $localStorage.failedMessages
            Auth.logout();
            $state.go('main-login');
            $localStorage.failedMessages = failedAudioMessages
        }

        function getMyStores() {
            vm.myStoresLoading = true;
            StoreService.getMyStores().then(function(response) {
                vm.myStores = response.data;
                if (vm.myStores && vm.myStores.length > 0) {
                    vm.myStores.forEach(function(store) {
                        if (store.logo) {
                            store.logoImage = store.logo;
                        } else {
                            var srcImageLogo = store.storeLogo;
                            if (srcImageLogo && srcImageLogo.split(',')[0].indexOf('base64') == -1) {
                                store.logoImage = store.storeLogo + '?dummy=' + new Date().getTime();
                            }
                        }
                    });
                }
                vm.myStoresLoading = false;
            });
        }

        function changeSession(storeId) {
            Auth.changeSession(storeId).then(
                function() {
                    $state.transitionTo('home', {}, {
                        reload: true,
                        inherit: false,
                        notify: true
                    });

                    if (Auth.getPreviousState()) {
                        var previousState = Auth.getPreviousState();
                        Auth.resetPreviousState();
                        $state.go(previousState.name, previousState.params);
                    }
                });
        }

        function storeChangeSuccessHandler() {
            getMyStores();
            getStoreInfo();
        }

        function changeState(state) {
            $state.go(state);
        }

        function subscribeButtonHandler() {
            // Prevent the user from clicking the subscribe button multiple times.
            Notification.requestPermission().then(function (result) {
                if (result === 'denied') {
                    return;
                }
                navigator.serviceWorker.getRegistration().then( function (registration) {
                    if (registration) {
                        registration.pushManager.getSubscription().then(function (subscribed) {
                            registration.pushManager.subscribe({
                                userVisibleOnly: true,
                                applicationServerKey: urlB64ToUint8Array('BF3vlHug3aBrL9pvwdHtLiOXi-AbBoZ_e-W5H_VMFoM8NwFV7vuRXz4jb2FJ6tcYSNJJqQqkfFgjkUn8jsAA7FA')
                            }).then(function (subscription) {
                                const subscriptionJSON = JSON.parse(JSON.stringify(subscription));
                                SettingsService.registerToReceiveNotifications(subscriptionJSON.endpoint,
                                    subscriptionJSON.keys.auth, subscriptionJSON.keys.p256dh, $localStorage.userId, $localStorage.defaultStore.storeId).then(function (data) {
                                    vm.registerId = data.id;
                                    vm.webNotifications = true;
                                });
                            });
                        });
                    } else {
                        vm.webNotifications = false;
                    }
                });
            });

        }

        function urlB64ToUint8Array(base64String) {
            const padding = '='.repeat((4 - base64String.length % 4) % 4);
            const base64 = (base64String + padding)
                .replace(/\-/g, '+')
                .replace(/_/g, '/');
            const rawData = window.atob(base64);
            const outputArray = new Uint8Array(rawData.length);
            for (var i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        }

        $rootScope.$on('user-logged-out', function () {
            $state.go($state.current, {}, {reload: true});
        });

        $rootScope.$on('profileImageChanged', function(event, newPath) {
            vm.profileImage = newPath;
        });

        SettingsService.getRegister($localStorage.userId, $localStorage.defaultStore.storeId).then(function (data) {
            vm.systemNotificationsSound = data['soundNotification'];
        });

        vm.checkedTermOfUse = function (storeType) {
            $uibModal.open({
                templateUrl: 'app/admin/term-of-use/term-of-use.html',
                controller: 'TermOfUseController',
                controllerAs: 'vm',
                scope: $scope,
                keyboard: false,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    storeType: function() {
                        return storeType;
                    }
                }
            });
        }

        vm.showSystemInfo = function() {
            $uibModal.open({
                templateUrl: 'app/admin/system-info-modal/system-info-modal.html',
                controller: 'systemInfoModalController',
                controllerAs: 'vm',
                keyboard: false,
                backdrop: 'static',
                size: 'sm',
            });
        }

        vm.openNotificationsModal = function () {
            vm.notificationsModal = $uibModal.open({
                templateUrl: 'app/admin/notification/modal/notificationList.html',
                controller: 'NotificationListController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false
            }).closed.then(function (response) {
                getNotificationsInfo();
            });
        }

        vm.isTrial = function(account) {
            return !isNullOrUndefined(account) && !isNullOrUndefined(account.remainingTime)
                && account.remainingTime > 0 && account.remainingTime <= 7;
        }

        vm.isIntegrationFailed = function() {
            return !isNullOrUndefined(vm.configuration) && !isNullOrUndefined(vm.configuration.id)
                && (vm.configuration.status == 'FAILED' || vm.configuration.status == 'INVALID_TOKEN');
        }

        vm.getActiveAlertType = function() {
            if (vm.isIntegrationFailed()) {
                return vm.AlertType.INTEGRATION;
            }
            if (vm.hasWebhookErrors) {
                return vm.AlertType.WEBHOOK;
            }
            if (vm.isTrial(vm.account)) {
                return vm.AlertType.TRIAL;
            }
            return null;
        }

        vm.isWarningAlert = function() {
            var alertType = vm.getActiveAlertType();
            return alertType === vm.AlertType.INTEGRATION || alertType === vm.AlertType.WEBHOOK;
        }

        vm.getAlertMessage = function() {
            var alertType = vm.getActiveAlertType();
            if (alertType === vm.AlertType.INTEGRATION) {
                if (isUnexpectedIntegrationPartner()) {
                    return vm.getIntegrationUnexpectedWarningMessage();
                }
                return vm.getIntegrationTokenFailedWarningMessage();
            }
            if (alertType === vm.AlertType.WEBHOOK) {
                return $translate.instant('global.top-navbar.message.warning.webhook-configurations-error');
            }
            if (alertType === vm.AlertType.TRIAL) {
                return vm.getTrialWarningMessage();
            }
            return '';
        }

        vm.hasAlertAction = function() {
            var alertType = vm.getActiveAlertType();
            if (alertType === vm.AlertType.TRIAL) {
                return true;
            }
            if (alertType === vm.AlertType.INTEGRATION) {
                return isBlingIntegrationPartner() || isUnexpectedIntegrationPartner();
            }
            return false;
        }

        vm.getAlertActionSref = function() {
            if (vm.getActiveAlertType() === vm.AlertType.INTEGRATION && isBlingIntegrationPartner()) {
                return ERPS_SETTINGS_STATE;
            }
            return null;
        }

        vm.getAlertActionHref = function() {
            var alertType = vm.getActiveAlertType();
            if (alertType === vm.AlertType.TRIAL) {
                return CHECKOUT_PATH;
            }
            if (alertType === vm.AlertType.INTEGRATION && isUnexpectedIntegrationPartner()) {
                return vm.getWhatsappIntegrationMessage();
            }
            return null;
        }

        vm.isExternalAlertAction = function() {
            return vm.getActiveAlertType() === vm.AlertType.INTEGRATION && isUnexpectedIntegrationPartner();
        }

        vm.getAlertActionLabelKey = function() {
            var alertType = vm.getActiveAlertType();
            if (alertType === vm.AlertType.TRIAL) {
                return 'global.top-navbar.button.sign-now';
            }
            if (alertType === vm.AlertType.INTEGRATION && isBlingIntegrationPartner()) {
                return 'global.top-navbar.button.config-access';
            }
            if (alertType === vm.AlertType.INTEGRATION && isUnexpectedIntegrationPartner()) {
                return 'global.top-navbar.button.contact-support';
            }
            return null;
        }

        vm.getAlertActionButtonClass = function() {
            var alertType = vm.getActiveAlertType();
            if (alertType === vm.AlertType.TRIAL) {
                return 'sign-now';
            }
            if (alertType === vm.AlertType.INTEGRATION && vm.hasAlertAction()) {
                return 'warning-app';
            }
            return '';
        }

        function isBlingIntegrationPartner() {
            return !isNullOrUndefined(vm.configuration)
                && vm.configuration.partnerId === Constants.ErpPartnerId.BLING;
        }

        function isUnexpectedIntegrationPartner() {
            return !isNullOrUndefined(vm.configuration)
                && (vm.configuration.partnerId === Constants.ErpPartnerId.VAREJO_ONLINE
                    || vm.configuration.partnerId === Constants.ErpPartnerId.NEXAAS);
        }

        vm.getErpName = function() {
            if (!isNullOrUndefined(vm.configuration) && !isNullOrUndefined(vm.configuration.partnerId)) {
                switch (vm.configuration.partnerId) {
                    case Constants.ErpPartnerId.VAREJO_ONLINE:
                        return "Varejo Online";
                    case Constants.ErpPartnerId.NEXAAS:
                        return "Nexaas";
                    case Constants.ErpPartnerId.BLING:
                        return "Bling";
                    default:
                        return "";
                }
            } else {
                return "";
            }
        }
    }
})();
